import React from "react"

import getTimeZoneOptions from "@helpers/getTimeZoneOptions"

import SelectInput from "./SelectInput"

const LABEL_PLACEHOLDER = "Select time zone"

const TimeZoneInput = ({
  form,
  request,
  itemProps,
  inputProps,
}) => {
  const options = getTimeZoneOptions()

  const extendedInputProps = {
    ...inputProps,
    placeholder: LABEL_PLACEHOLDER
  }

  return <SelectInput
    form={form}
    request={request}
    itemProps={itemProps}
    inputProps={extendedInputProps}
    isMultiple={false}
    options={options}
  />
}

export default TimeZoneInput
